'use client';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

export default function Header() {
  return (
    // Keep this non-fixed so the header scrolls naturally until the sticky element takes over.
    <header className="w-full font-sans">
      <MobileHeader />
      <DesktopHeader />
    </header>
  );
}